<template>
  <footer class="uk-container footer">
    <hr />
    <p :class="sectionClass">All content &copy; Nathan Nankervis {{ year }}</p>
  </footer>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  data() {
    let d = new Date()
    return {
      year: d.getFullYear(),
    }
  },

  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding: 4% 0% 8%;
  color: white;
}

.sectionMobile {
  padding: 6% 0% 12%;
  font-size: small;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue